export default __webpack_public_path__ + "static/media/emoji_sad.cfb61ae8.svg";